<template>
    <div class="flex">
        <div class="flex my-auto items-center ml-5" ref="start">
            <input class="text-md mr-3" type="date" :max="dateEnd" name="from" v-model="dateStart" ref="dateStartInput"/>
            -
            <input class="text-md mx-3" :min="dateStart" type="date" name="to" v-model="dateEnd" ref="endDateInput"/>
        </div>
        <a :href="route('auctions.analytics.download.bids', {dateStart: this.dateStart, dateEnd: this.dateEnd})">
            <button class="btn btn-primary">
                {{$t('pages.analytics.tabs.reports.download_bids')}}
            </button>
        </a>
    </div>
</template>

<script>
    import moment from "moment/moment";

    export default {
        name: "AuctionReports",

        data() {
            return {
                dateStart: this.getStartDate || '',
                dateEnd: this.getEndDate || '',
            }
        },
        computed: {
            getStartDate() {
                if (this.$route().params?.dateStart) {
                    let dateParts = this.$route().params?.dateStart.split('-');
                    return moment(new Date(dateParts[0], dateParts[1]-1, dateParts[2])).format('YYYY-MM-DD');
                }
                return moment(Date.now()).subtract(30, "days").format('YYYY-MM-DD');
            },
            getEndDate() {
                if (this.$route().params?.dateEnd) {
                    let dateParts = this.$route().params?.dateEnd.split('-');
                    return moment(new Date(dateParts[0], dateParts[1]-1, dateParts[2])).format('YYYY-MM-DD');
                }
                return moment(new Date()).format('YYYY-MM-DD');
            },
        }
    }
</script>
